import { client } from 'data/client';
import { Input as GetUserResponse } from 'model/user';

export async function getMe() {
  const { data } = await client.get<GetUserResponse>('/users/me');
  return data;
}
